import {AxiosRequestConfig} from 'axios'

// eslint-disable-next-line
import {sendRequest} from '../utils/axios'
import {APIDomain} from './constants'

export type RequestConfig<T> = AxiosRequestConfig<T>

export const getAPIURL = (endpoint: string): string => `${APIDomain}${endpoint}`

export const API = {
  get: <L, T>(endpoint: string, options = {}) =>
    sendRequest<T>('get', getAPIURL(endpoint), undefined, options as RequestConfig<L>),
  post: <L, T>(endpoint: string, data?: any, options = {}) =>
    sendRequest<T>('post', getAPIURL(endpoint), data, options as RequestConfig<L>),
  delete: <L, T>(endpoint: string, options = {}) =>
    sendRequest<T>('delete', getAPIURL(endpoint), undefined, options as RequestConfig<L>),
  put: <L, T>(endpoint: string, data?: any, options = {}) =>
    sendRequest<T>('put', getAPIURL(endpoint), data, options as RequestConfig<L>),
  patch: <L, T>(endpoint: string, data?: any, options = {}) =>
    sendRequest<T>('patch', getAPIURL(endpoint), data, options as RequestConfig<L>),
}
